/**
 * Paid PDF Audit Service - Frontend API calls for auditing/enqueueing paid invoice PDFs
 */

import api from "@/shared/api";

export async function auditPaidInvoicePdfs({
  sinceDays = 180,
  maxScan = 5000,
  limit = 200,
  checkFirebase = false,
  jobId = null,
} = {}) {
  const params = {
    sinceDays,
    maxScan,
    limit,
    checkFirebase,
    ...(jobId ? { jobId } : {}),
  };

  return await api.get("/invoices/paid-pdf/audit", { params });
}

export async function enqueueMissingPaidInvoicePdfs({
  invoiceIds,
  reason = "ui-audit-batch",
} = {}) {
  return await api.post("/invoices/paid-pdf/enqueue-missing", {
    invoiceIds,
    reason,
  });
}

